import React, { useEffect, useRef, useState } from "react";

/** Minimal popover that opens upward from the chat input bar and closes on outside click / Escape */
export function Popover({ trigger, children, disabled }: { trigger: React.ReactNode; children: React.ReactNode; disabled?: boolean }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div ref={ref} className="relative shrink-0">
      <button type="button" disabled={disabled} onClick={() => setOpen((v) => !v)} className="disabled:opacity-40">
        {trigger}
      </button>
      {open && (
        <div className="absolute bottom-full left-0 mb-2 z-20 rounded-xl border bg-popover p-2 shadow-lg" onClick={(e) => e.stopPropagation()}>
          {children}
        </div>
      )}
    </div>
  );
}
